import { format } from 'date-fns';
import { nb } from 'date-fns/locale';
import { CompetitionAnswer, CompetitionQuestion } from './Competition.types';

export const getAnswerLabel = (index: number): string => {
  const labels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  return labels[index] || String.fromCharCode(65 + index); // Fallback to A, B, C, etc.
};

export const getAnswerById = (
  questionId: string,
  answerId: string,
  questions: CompetitionQuestion[],
): CompetitionAnswer | undefined => {
  const question = questions.find((q) => q.key === questionId);
  return question?.answers.find((a) => a.key === answerId);
};

export const getAnswerIndex = (question: CompetitionQuestion, answerId: string): number =>
  question.answers.findIndex((a) => a.key === answerId);

export const formatEndDate = (endDate?: string | null): string | undefined => {
  if (!endDate) {
    return undefined;
  }

  const date = new Date(endDate);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  if (date.getUTCFullYear() < 2000) {
    return undefined;
  }

  return format(date, 'd. MMMM yyyy', { locale: nb });
};
